/**
 * keeps constants in one place to avoid overwriting.
 */

// ROUTES
export const ENTRY_ROUTE = '/'
export const HOME = ENTRY_ROUTE + 'home'
export const QUIZ = ENTRY_ROUTE + 'quiz'

// QUESTIONS STATE
export const SET_QUESTIONS = 'SET_QUESTIONS'
export const ANSWER_QUESTION = 'ANSWER_QUESTION'
export const RESET_QUESTIONS = 'RESET_QUESTIONS'
export const SET_ERROR = 'SET_ERROR'
